import { PortfolioDetailData } from '@/data/portfolio/portfolio-detail-data';
import './portfolio-content-images.scss';
import useDeviceSize from '@/hooks/useDeviceSize';
type Props = {
	contentImages: PortfolioDetailData['contentImages'];
};

const PortfolioContentImages = ({ contentImages }: Props) => {
	// const { pc, tablet, mobile } = contentImages;

	const { deviceSize } = useDeviceSize();

	const images = contentImages[deviceSize];

	return (
		<div className="portfolio-content-images-wrapper">
			{images.map((image, index) => (
				<img
					key={index}
					src={image}
					alt={`portfolio-content-images-${index}`}
				/>
			))}
		</div>
	);
};

export default PortfolioContentImages;
